import {
  Avatar,
  Box,
  IconButton,
  Menu,
  MenuItem,
  MenuProps,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { styled, useTheme } from "@mui/material/styles";
import styles from "./css/ProfileButton.module.css";
import Divider from "@mui/material/Divider";
import { KeycloakClientFactory } from "../../../helper/keycloak/factory";
import { ConfirmationModal } from "../../../components/ConfirmationModal";

const StyledProfileMenu = styled((props: MenuProps) => <Menu {...props} />)(
  ({ theme }) => ({
    "& .MuiPaper-root": {
      width: "350px",
    },
  })
);

export const ProfileButton = () => {
  // TODO - need to enable these features - G2XT-2263
  // const generalSettings = ["My Collections", "Contact Us", "Gadget History"];
  // const personalSettings = ["Account Settings"];
  const theme = useTheme();
  const keycloak = KeycloakClientFactory.getInstance();
  const userData = keycloak.getIdToken();
  const [anchorElUser, setAnchorElUser] = useState<null | HTMLElement>(null);
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => setAnchorElUser(event.currentTarget);
  const handleCloseUserMenu = () => setAnchorElUser(null);
  const [openModal, setOpenModal] = useState(false);
  const handleCloseModal = () => setOpenModal(false);
  const handleOnSignOut = () => keycloak.logout();
  const openConfirmationModal = () => {
    handleCloseUserMenu();
    setOpenModal(true)
  }

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="User Menu">
        <IconButton
          data-testid="profile-btn"
          onClick={handleOpenUserMenu}
          sx={{ p: 0 }}
        >
        <Avatar alt="User Initials" style={{backgroundColor: theme.palette.primary.main}}>
          {userData?.given_name?.[0]?.toUpperCase() || ''}{userData?.family_name?.[0]?.toUpperCase() || ''}
        </Avatar>
        </IconButton>
      </Tooltip>
      <StyledProfileMenu
        sx={{ mt: "45px" }}
        id="menu-appbar"
        data-testid="menu-bar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        <MenuItem>
          <Stack>
            <Typography className={styles.userGreetingMessage} textAlign="left">
              Hello&nbsp;
              <Typography
                data-testid="logged-in-user"
                className={styles.loggedInUser}
                component="span"
              >
                {userData?.given_name + " " + userData?.family_name}
              </Typography>
            </Typography>
            <Typography variant="subtitle1">{userData?.email}</Typography>
          </Stack>
        </MenuItem>
        <Divider />
        {/* {generalSettings.map((settingItem) => (
          <MenuItem key={settingItem} onClick={handleCloseUserMenu}>
            <Typography
              className={styles.generalSettingsMenu}
              textAlign="center"
            >
              {settingItem}
            </Typography>
          </MenuItem>
        ))}
        <Divider />
        {personalSettings.map((settingItem) => (
          <MenuItem key={settingItem} onClick={handleCloseUserMenu}>
            <Typography
              className={styles.generalSettingsMenu}
              textAlign="center"
            >
              {settingItem}
            </Typography>
          </MenuItem>
        ))} */}
        <MenuItem onClick={openConfirmationModal} className={styles.signOutMenu}>
          {"Log Out"}
        </MenuItem>
      </StyledProfileMenu>
      <ConfirmationModal
        open={openModal}
        handleClose={handleCloseModal}
        headerText="Logout Confirmation"
        descriptionText="You are about to log out. This action will log you out of all applications where you are currently signed in using Single Sign-On (SSO). Do you wish to continue ?"
        agreeText="Log Out"
        disAgreeText="Cancel"
        onAgree={handleOnSignOut}
      />
    </Box>
  );
};
